import { fetch } from '../utils/fetch'

// 获取最新数据
export function getWorkBoardTotal(params) {
  return fetch({
    url: '/bd/workBoard/totalCount',
    method: 'get',
    params
  })
}

// 获取信息提醒
export function getWorkBoardNotice(params) {
  return fetch({
    url: '/bd/workBoard/noticeCount',
    method: 'get',
    params
  })
}

// 数据看板——行业统计
export function getIndustryCount(params) {
  return fetch({
    url: '/bd/workBoard/industryCount',
    method: 'get',
    params
  })
}

// 数据看板——渠道统计
export function getChannelCount(params) {
  return fetch({
    url: '/bd/workBoard/channelCount',
    method: 'get',
    params
  })
}

// 数据看板——签约客户
export function getContractRankList(params) {
  return fetch({
    url: '/bd/saleBoard/contractRankList',
    method: 'get',
    params
  })
}

// 数据看板——销售业绩
export function getSaleCount(params) {
  return fetch({
    url: '/bd/workBoard/saleCount',
    method: 'get',
    params
  })
}

// 用户列表
export function getUserList(params) {
  return fetch({
    url: '/bd/saleBoard/userList',
    method: 'get',
    params
  })
}

// 销售看板——销售数据表
export function getSaleData(params) {
  return fetch({
    url: '/bd/saleBoard/saleData',
    method: 'get',
    params
  })
}

// 销售看板——客户信息
export function getCustomerMsg(params) {
  return fetch({
    url: '/bd/saleBoard/customer',
    method: 'get',
    params
  })
}

// 销售看板——客户状态分部
export function customerType(params) {
  return fetch({
    url: '/bd/saleBoard/status',
    method: 'get',
    params
  })
}

// 销售看板——业绩统计
export function getPerformance(params) {
  return fetch({
    url: '/bd/saleBoard/performance',
    method: 'get',
    params
  })
}

// 销售看板——跟进统计
export function getFollowList(params) {
  return fetch({
    url: '/bd/saleBoard/follow',
    method: 'get',
    params
  })
}

// 业绩数据
export function getperformanceList(params) {
  return fetch({
    url: '/bd/saleBoard/performanceList',
    method: 'get',
    params
  })
}

// 业绩详情
export function getSalesPerformanceDetail(params) {
  return fetch({
    url: '/bd/saleBoard/salesPerformanceDetail',
    method: 'get',
    params
  })
}

// 关键指标
export function getQueryIndicators(params) {
  return fetch({
    url: '/bd/workBoard/queryIndicators',
    method: 'get',
    params
  })
}

// 销售一览表
export function getSalesman(params) {
  return fetch({
    url: '/bd/workBoard/salesman',
    method: 'get',
    params
  })
}

// 查询本人所有导出导入任务
export function getTaskList(data) {
  return fetch({
    url: '/WX/selectTasksByIf',
    method: 'post',
    data
  })
}

// 下载列表
export function Download(params) {
  return fetch({
    url: '/returnDownloadUrl',
    method: 'get',
    params
  })
}

// 通知列表
export function getNews(userId, data) {
  return fetch({
    url: `/WX/selectAllWxNews/${userId}`,
    method: 'post',
    data
  })
}

// 通知分类列表
export function getEnum() {
  return fetch({
    url: '/WX/selectAllWxMsgTypeEnum',
    method: 'post'
  })
}

// 修改已读状态
export function isRead(id) {
  return fetch({
    url: `/WX/updateWxNews/${id}`,
    method: 'post'
  })
}

// 消息列表通知
export function allMsgList(data) {
  return fetch({
    url: '/WX/selectAllWxNews',
    method: 'post',
    data
  })
}

// 全部已读
export function allRead(userId, data) {
  return fetch({
    url: `/WX/updateAllRead/${userId}`,
    method: 'post',
    data
  })
}

// 批量已读
export function batchRead(data) {
  return fetch({
    url: '/WX/batchUpdateWxNews',
    method: 'post',
    data
  })
}

// 导出工作一揽表
export function downloadWorkSale(params) {
  return fetch({
    url: '/workBoardSalesman/export',
    method: 'get',
    params
  })
}

// 导出业绩数据
export function downloadPerformance(params) {
  return fetch({
    url: '/performanceList/export',
    method: 'get',
    params
  })
}

// 导出关联订单业绩数据
export function downloadPerformanceOrder(params) {
  return fetch({
    url: '/performanceAndOrder/export',
    method: 'get',
    params
  })
}

// 导出业绩详情
export function downloadPerformanceDetail(params) {
  return fetch({
    url: '/performanceListDetails/export',
    method: 'get',
    params
  })
}

// 导出关键指标
export function downloadIndicators(params) {
  return fetch({
    url: '/indicators/export',
    method: 'get',
    params
  })
}

// 导出关键指标
export function withdraw(id) {
  return fetch({
    url: `/crmBusiness/business/revokeTask/${id}`,
    method: 'get'
  })
}
